/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CompletedEvaluationGrading } from './completedEvaluationGrading';
import type { _CompletedEvaluationLinks } from './_completedEvaluationLinks';

/**
 * A completed evaluation for a lecturer, including additional properties from
the terminal selection example.
 */
export interface CompletedEvaluation {
  userId: string;
  moduleId: string;
  courseId: string;
  moduleName: string;
  userName: string;
  submissionDate: string;
  dueDate: string;
  grading: CompletedEvaluationGrading;
  _links: _CompletedEvaluationLinks;
}
